export default __webpack_public_path__ + "static/media/IconDesc_Dbl_Ramp_8x8x1_01.256.00f7552a.png";